import React, { useMemo, useState } from 'react';
import ENV from './ENV';
import AddNewBtn from './component/AddNewBtn';
import swal from 'sweetalert';
import { ProgressSpinner } from 'primereact/progressspinner';
import $ from 'jquery';

const Form = () => {
    document.title = "STGC | ADC";
    const [inputvalue, setInputValue] = useState({
        "visible": false,
        "login": {
            "session_code": '',
        },
        "info": {
            "id_customer": '',
            "customer_name": '',
            "customer_contact": '',
            "customer_address": '',
            "contact_person": '',
            "email_address": '',
            "tin": '',
        },
        "oldinfo": {},
        "auth": {
            "username": "",
            "password": "",
        },
        "customer_list": [],
        "session_code": '',
        "selected": false,
        "loading": false,
        "selecteditem": 0
    });

    const [mouseevent, setMouseEnterEvent] = useState(false);
    const [hoverevent, setMouseHoverEvent] = useState(0);

    const handlekey = (e) => {
        if (inputvalue.info.customer_name !== "" || inputvalue.info.customer_contact !== 0) {
            if (inputvalue.selecteditem < [...inputvalue.customer_list].filter((i) => {
                return i;
            }).slice(0, 10).length) {
                if (e.key === 'ArrowUp' && inputvalue.selecteditem > 0) {
                    setInputValue(prev => ({ ...prev, "selecteditem": prev.selecteditem - 1 }))
                } else if (e.key === 'ArrowDown' && inputvalue.selecteditem < [...inputvalue.customer_list].filter((i) => {
                    return i;
                }).slice(0, 10).length - 1) {
                    setInputValue(prev => ({ ...prev, "selecteditem": prev.selecteditem + 1 }))
                } else if (e.key === 'Enter' && inputvalue.selecteditem >= 0) {
                    setInputValue(prev => ({
                        ...prev,
                        "info": {
                            ...prev.info, ...[...inputvalue.customer_list].filter((i) => {
                                return i;
                            })[inputvalue.selecteditem]
                        },
                        "oldinfo": {
                            ...prev.info, ...[...inputvalue.customer_list].filter((i) => {
                                return i;
                            })[inputvalue.selecteditem]
                        },
                        "selected": true
                    }))
                }
            } else {
                setInputValue(prev => ({ ...prev, "selecteditem": -1 }))
            }
        }
    }

    // sessionStorage.clear();

    if (sessionStorage.getItem("session_loggedin") === null) {
        return (
            <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", height: window.innerHeight }}>
                <div>
                    <div style={{ width: "100%", height: "100%", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
                        <h2 className="mgbt-xs-5"><img src="https://x.stgc.store/logo-stgc.jpg" alt="logo" style={{ width: 200, borderRadius: 20 }} /></h2>
                        <p style={{ fontSize: 30, fontWeight: "bolder" }}>Strategic Technologies</p>
                    </div>
                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", gap: 10 }}>
                        {
                            inputvalue.loading ?
                                <ProgressSpinner style={{ width: 30, height: 30, margin: 0 }} strokeWidth="5" fill="var(--surface-ground)" animationDuration=".5s" />
                                :
                                <span style={{ fontSize: 18, fontWeight: "bolder" }}>Enter Code:</span>
                        }
                        <input type='password' style={{ textAlign: "center", width: 150 }}
                            onKeyPress={(e) => {
                                if (e.key === "Enter") {
                                    e.preventDefault();
                                    setInputValue(prev => ({ ...prev, "loading": true }))

                                    var session = $.ajax({
                                        url: ENV.DOMAIN + 'api/customer.php',
                                        type: "POST",
                                        data: {
                                            "session_2": 1,
                                            "inputvalue": JSON.stringify(inputvalue)
                                        },
                                        dataType: "json",
                                        success: function (data) {
                                            console.log(data)
                                            if (data[0].status === 'success') {
                                                swal({
                                                    text: "Successfully",
                                                    icon: "success",
                                                    timer: 1000,
                                                    button: false,
                                                }).then(() => {
                                                    sessionStorage.setItem("session_loggedin", 'success')
                                                    window.location.assign("/")
                                                });
                                            } else if (data[0].status === 'invalid_otp') {
                                                swal({
                                                    text: "Invalid OTP",
                                                    icon: "error",
                                                    timer: 1000,
                                                    button: false,
                                                }).then(() => {
                                                    setInputValue(prev => ({ ...prev, "loading": false }))
                                                });
                                            }
                                            session.abort()
                                        }
                                    });
                                }
                            }}
                            onChange={(e) => {
                                setInputValue(prev => ({ ...prev, "login": { "session_otp": e.target.value } }))
                            }} className="form-control" id="exampleInputEmail1" placeholder="000000" autoComplete='off' />
                    </div>
                </div>
            </div>
        )
    } else {
        return (
            <div style={{ padding: 10 }}>
                <br />
                <div className='row'>
                    <div className='col-sm-3'>
                        <div style={{ width: "100%", height: "100%", display: "flex", flexDirection: "column", justifyContent: "flex-start", alignItems: "center" }}>
                            <h2 className="mgbt-xs-5"><img src="https://x.stgc.store/logo-stgc.jpg" alt="logo" style={{ width: 200, borderRadius: 20 }} /></h2>
                            <p style={{ fontSize: 30, fontWeight: "bolder" }}>Strategic Technologies</p>
                        </div>
                    </div>
                    <div className='col-sm-4' style={{ height: window.innerHeight, display: "flex", flexDirection: "column", justifyContent: "flex-start", alignItems: "center" }}>
                        <div style={{ width: "100%" }}>
                            <div className="form-group">
                                <label>FullName / Company Name</label>
                                <input onChange={(e) => {
                                    setInputValue(prev => ({
                                        ...prev,
                                        "info": {
                                            ...prev.info,
                                            "customer_name": e.target.value
                                        },
                                        "selected": false
                                    })) //, "customer_list": [...data]

                                    if (e.target.value !== "") {
                                        var search_user = $.ajax({
                                            url: ENV.DOMAIN + 'api/customer.php',
                                            type: "POST",
                                            data: {
                                                "search_customer": 1,
                                                "inputvalue": JSON.stringify({ "info": { "customer_name": e.target.value } })
                                            },
                                            dataType: "json",
                                            success: function (data) {
                                                console.log(data)
                                                setInputValue(prev => ({ ...prev, "customer_list": data }))
                                                search_user.abort();
                                            }
                                        });
                                    }
                                    //  onKeyDown={handlekey}
                                }} value={inputvalue.info.customer_name} onKeyDown={handlekey} onFocus={(e) => setMouseEnterEvent(true)} onMouseEnter={(e) => setMouseEnterEvent(true)} onMouseLeave={(e) => setMouseEnterEvent(false)} className="form-control" placeholder="" autoComplete='off' />

                            </div>
                            <div className="form-group">
                                <label>Mobile / Telephone</label>
                                <input onChange={(e) => {
                                    setInputValue(prev => ({
                                        ...prev,
                                        "info": {
                                            ...prev.info,
                                            "customer_contact": e.target.value,
                                        }
                                    }))
                                }}
                                    onKeyDown={handlekey} onFocus={(e) => setMouseEnterEvent(true)} onMouseEnter={(e) => setMouseEnterEvent(true)} onMouseLeave={(e) => setMouseEnterEvent(false)} value={inputvalue.info.customer_contact} className="form-control" placeholder="" autoComplete='off' />
                            </div>
                            <div className="form-group">
                                <label>Address</label>
                                <textarea onChange={(e) => setInputValue(prev => ({ ...prev, "info": { ...prev.info, "customer_address": e.target.value } }))} value={inputvalue.info.customer_address} className="form-control" style={{ width: "100%" }} autoComplete='off'></textarea>
                            </div>
                            <div className="form-group">
                                <label>Contact Person / Contact Number</label>
                                <textarea onChange={(e) => setInputValue(prev => ({ ...prev, "info": { ...prev.info, "contact_person": e.target.value } }))} value={inputvalue.info.contact_person} className="form-control" style={{ width: "100%" }} autoComplete='off'></textarea>
                            </div>
                            <div className="form-group">
                                <label>Email</label>
                                <input onChange={(e) => setInputValue(prev => ({ ...prev, "info": { ...prev.info, "email_address": e.target.value } }))} value={inputvalue.info.email_address} className="form-control" placeholder="" autoComplete='off' />
                            </div>
                            <div className="form-group">
                                <label>Tin</label>
                                <input onChange={(e) => setInputValue(prev => ({ ...prev, "info": { ...prev.info, "tin": e.target.value } }))} value={inputvalue.info.tin} className="form-control" placeholder="" autoComplete='off' />
                            </div>
                        </div>
                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", width: "100%" }}>
                            <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", gap: 10 }}>
                                {
                                    inputvalue.info.customer_name !== '' || inputvalue.info.customer_contact !== '' || inputvalue.info.customer_address !== '' ?
                                        <button onClick={() => {
                                            setInputValue(prev => ({
                                                "info": {
                                                    "id_customer": '',
                                                    "customer_name": '',
                                                    "customer_contact": '',
                                                    "customer_address": '',
                                                    "contact_person": '',
                                                    "email_address": '',
                                                    "tin": '',
                                                },
                                                "selected": false
                                            }))
                                        }} className="btn btn-danger">Reset</button> : null // <button className="btn btn-default">Reset</button>
                                }
                                {
                                    inputvalue.info.id_customer !== '' ?
                                        (
                                            inputvalue.customer_name !== inputvalue.oldinfo.customer_name || inputvalue.info.customer_contact !== inputvalue.oldinfo.customer_contact || inputvalue.info.customer_address !== inputvalue.oldinfo.customer_address ?
                                                // <button onClick={() => UpdateData()} className="btn btn-primary">Update</button>
                                                <AddNewBtn status="update" label={"Update"} inputvalue={inputvalue} setInputValue={setInputValue} className="btn btn-success" />
                                                : null
                                            // <button className="btn btn-default">Update</button>
                                        )
                                        : null
                                    // <button className="btn btn-default">Update</button>
                                }
                                {
                                    inputvalue.info.id_customer !== '' ?
                                        inputvalue.info.customer_name !== inputvalue.oldinfo.customer_name || inputvalue.info.customer_contact !== inputvalue.oldinfo.customer_contact || inputvalue.info.customer_address !== inputvalue.oldinfo.customer_address ?
                                            null
                                            :
                                            <AddNewBtn status="submit" label={"Submit"} inputvalue={inputvalue} setInputValue={setInputValue} className="btn btn-primary" />
                                        // <button onClick={() => Submit()} className="btn btn-primary">Submit</button>
                                        : null
                                    // <button className="btn btn-default">Submit</button>
                                }
                            </div>
                            {
                                inputvalue.info.customer_name !== '' && inputvalue.info.customer_contact !== '' && inputvalue.info.customer_address !== '' ?
                                    (
                                        inputvalue.info.id_customer !== '' ?
                                            null
                                            // <button className="btn btn-default">Add New</button>
                                            :
                                            <AddNewBtn status="add_new" label={"Add New"} inputvalue={inputvalue} setInputValue={setInputValue} className="btn btn-primary" />
                                    ) : null
                                // <button className="btn btn-default">Add New</button>
                            }
                        </div>
                    </div>
                    <div className='col-sm-5' style={{ height: window.innerHeight, display: "flex", flexDirection: "row", justifyContent: "flex-start", alignItems: "flex-start", paddingLeft: 50, paddingRight: 50 }}>
                        {
                            mouseevent ?
                                (
                                    (inputvalue.info.customer_name !== '' && inputvalue.selected === false) || (inputvalue.info.customer_contact !== '' && inputvalue.selected === false) ?
                                        (
                                            [...inputvalue.customer_list].filter((i) => {
                                                return i
                                            }).length > 0 ?
                                                (
                                                    <div style={{ position: "absolute", left: -10, zIndex: 1, borderRadius: 5, width: "100%", boxShadow: "-1px 1px 5px grey", width: 500 }}>
                                                        {
                                                            [...inputvalue.customer_list].filter((i) => {
                                                                return i;
                                                            }).map((item, key) => {
                                                                return (
                                                                    <div
                                                                        onMouseEnter={(e) => {
                                                                            setMouseEnterEvent(true)
                                                                            // setSelectedItem(key)
                                                                            setInputValue(prev => ({ ...prev, "selecteditem": key }))
                                                                        }}
                                                                        onMouseLeave={(e) => {
                                                                            setMouseEnterEvent(false)
                                                                            // setSelectedItem(key)
                                                                            setInputValue(prev => ({ ...prev, "selecteditem": key }))
                                                                        }}
                                                                        onClick={() => {
                                                                            setInputValue(prev => ({ ...prev, "info": { ...prev.info, ...item }, "oldinfo": { ...prev.oldinfo, ...item }, "selected": true }))
                                                                            // setInputValueOld({ ...item, "selected": true })
                                                                        }} key={key} style={{ backgroundColor: "#fff", width: "100%", border: "1px solid #ddd", cursor: "pointer", padding: 5, backgroundColor: inputvalue.selecteditem === key ? "#ddd" : "#fff" }}>
                                                                        <div>Name: <span style={{ fontWeight: "bolder" }}>{item.customer_name}</span></div>
                                                                        <div>No.: <span style={{ fontWeight: "bolder" }}>{item.customer_contact}</span></div>
                                                                        <div>Address: {item.customer_address}</div>
                                                                    </div>
                                                                )
                                                            }).slice(0, 10)
                                                        }
                                                    </div>
                                                ) : null
                                        ) : null
                                ) : null
                        }


                        <div className="panel-body" style={{ width: '100%', height: '', background: '#fff', wordWrap: 'break-word' }}>
                            <div className="text-center"><h3>Policy</h3></div>
                            1.{")"} NO RECEIPT / NO ORIGINAL BOX, PACKAGING, ACCESSORIES = NO WARRANTY STRATEGIC TECHNOLOGIES DOES NOT PROVIDE A COPY OF THE RECEIPT IF CLIENT LOST THE ORIGINAL COPY. <br />
                            2.{")"} ALWAYS MAKE IT A HABIT TO KEEP ALL ORIGINAL PACKAGING, ACCESSORIES AND RECEIPT IF NEEDED FOR WARRANTY AT A LATER DATE.<br /><br />
                            3.{")"} “WARRANTY DOES NOT MEAN OUTRIGHT REPLACEMENT OR REFUND” Item will be sent to respective supplier / distributor for repair, provided materials  and parts for that particular product are still available.  This will take minimum of 45-60 days lead time upon receipt of the supplier / distributor (SHIPPING LEADTIME TO SUPPLIER AND BACK TO THE STORE IS NOT PART OF THE 45-60 DAYS LEAD TIME)<br /><br />
                            4.{")"} “WARRANTY DOES NOT MEAN EXCHANGE BECAUSE YOU PURCHASED THE WRONG ITEM” “Compatibility is NOT part of the warranty” COMPATIBILITY IS BUYER’S RESPONSIBILITY. NO CASH REFUND WE SELL PC PARTS AND COMPONENTS ONLY. WE DO NOT OFFER SOLUTIONS<br /><br />
                            5.{")"} “INDECISION” OR “CHANGE OF MIND” IS NOT AN EXCUSE OR BASIS FOR VALIDITY OF RETURN.   RA 7394 The Consumer Act of the Philippines  Change of mind on the part of the buyer does not entitle the buyer to an exchange or refund  PHYSICAL DAMAGE AND CLIENT NEGLECT IS NOT PART OF THE WARRANTY. (VOID WARRANTY)<br /><br />
                            6.{")"} IT IS ALSO THE DUTY AND RESPONSIBILITY OF THE CUSTOMER TO DOUBLE CHECK THEIR ITEMS AS THEY ARE RELEASED.<br />
                        </div>
                    </div>
                </div>

            </div>
        );
    }

    // if ([...inputvalue.customer_list].length > 0) {
    // } else {
    //     return (
    //         <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", height: window.innerHeight }}>
    //             <div>
    //                 <div style={{ width: "100%", height: "100%", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
    //                     <h2 className="mgbt-xs-5"><img src="https://x.stgc.online/logo-stgc.jpg" alt="logo" style={{ width: 200, borderRadius: 20 }} /></h2>
    //                     <p style={{ fontSize: 30, fontWeight: "bolder" }}>Strategic Technologies</p>
    //                     <ProgressSpinner style={{ width: 30, height: 30, margin: 0 }} strokeWidth="5" fill="var(--surface-ground)" animationDuration=".5s" />
    //                 </div>
    //             </div>
    //         </div>
    //     )
    // }


}

export default Form;
